import { render, staticRenderFns } from "./Endereco.vue?vue&type=template&id=b0a2dfb4&lang=html"
import script from "./Endereco.vue?vue&type=script&lang=js"
export * from "./Endereco.vue?vue&type=script&lang=js"
import style0 from "./Endereco.vue?vue&type=style&index=0&id=b0a2dfb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports